/** @module components */
import React from "react";
import Progress from "antd/lib/progress";
import Modal from "antd/lib/modal";
import "antd/lib/progress/style/index.css";
import "antd/lib/modal/style/index.css";
export {
/**
 * @see https://ant.design/components/progress/
 * @returns React.Element
 * @function Progress
 */
Progress
/**
 * @see https://ant.design/components/modal/
 * @returns React.Element
 * @function Modal
 */
, Modal };
/**
 * Create a WordPress dash icon.
 *
 * @property {string} name The icon
 * @see https://developer.wordpress.org/resource/dashicons/
 * @returns React.Element
 * @function
 */

export var DashIcon = function DashIcon(_ref) {
  var name = _ref.name;
  return /*#__PURE__*/React.createElement("span", {
    className: "dashicons dashicons-" + name
  });
};